import React = require("react");
import ReactDom = require("react-dom");
import {Provider} from "react-redux";
import {quickMap} from 'webmapsjs/dist/olHelpers/quickMap';
import {makeServiceUrl, LayerEsriMapServer, LayerEsriMapServerOptions} from 'webmapsjs/dist/layers/LayerEsriMapServer';
import {makeServiceUrl as esriMakeServiceUrl, LayerBaseVectorEsri, LayerBaseVectorEsriOptions} from 'webmapsjs/dist/layers/LayerBaseVectorEsri';
import * as ax from 'webmapsjs/dist/api/axios';
import {connect} from "react-redux";
import {iConfig} from './interfaces';
import * as actions from './actions';
import {YearQuarterMetric} from './YearQuaterMetric';
import * as cnst from './const';

import * as store from './store'
import {getState} from './store';
import {iSetConfig, iSetQuarter, iSetYear} from "./actions";
import {Legend} from './Legend';

declare const glob: Object;


store.store.subscribe(() => {
    let s = getState();
    console.log(s);

    let newParams = cnst.genParams(s.metric, s.period, s.year, s.quarter);
    cnst.segLayerSource.updateParams(newParams);

    if (!cnst.segLayer.getVisible() && newParams){
        cnst.segLayer.setVisible(true);
    }
});

class _Mapss extends React.Component<{
    setConfig: (s: iConfig) => any
}, {}> {

    componentDidMount() {
        const map = quickMap(
            {
                divId: 'map',
                center: {
                    x: -10060208,
                    y: 5437740
                },
                zoom: 8,
                minZoom: 7
            });

        glob['map'] = map;

        // let lyr = new LayerEsriMapServer(
        //     makeServiceUrl('NPMRDS', 'mapss'),
        //     {}
        // );

        map.addLayer(cnst.segLayer);
        map.addLayer(cnst.mpaLayer);
        map.addLayer(cnst.countyLayer);

        ax.get(window.location.href + '/config', (d: iConfig) => {
            this.props.setConfig(d);
        }, {rand: Math.random().toString()});
    }

    render() {
        return <div id="outer-container">
            <div id="map"></div>
            <div id="sidebar">
                <YearQuarterMetric/>

            </div>
        </div>

    }
}

const Mapss = connect(
    (s: store.iState) => {
        return {};
    },
    (dispatch) => {
        return {
            setConfig: (c: iConfig) => {
                dispatch({type: actions.SET_CONFIG, config: c} as iSetConfig);

                let yearInd = c.npmrdsYears.length - 1;

                for (let i = yearInd; i > -1; i--) {
                    let theYear = c.npmrdsYears[i];
                    let quarterArr = c.yearQuarter[theYear.toFixed()];

                    if (!quarterArr) {
                        continue;
                    }
                    dispatch({type: actions.SET_YEAR, year: theYear} as iSetYear);
                    dispatch({type: actions.SET_QUARTER, quarter: quarterArr[quarterArr.length - 1]} as iSetQuarter);

                    break;


                }


            }
        };
    })(_Mapss);

ReactDom.render(<Provider store={store.store}><Mapss/></Provider>, document.getElementById('root'));


